import { render, staticRenderFns } from "./wvp.vue?vue&type=template&id=40cb9d50&scoped=true"
import script from "./wvp.vue?vue&type=script&lang=js"
export * from "./wvp.vue?vue&type=script&lang=js"
import style0 from "./wvp.vue?vue&type=style&index=0&id=40cb9d50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb9d50",
  null
  
)

export default component.exports